import { useBreadcrumb } from "features/breadcrumbs";
import ListaEncomenda from "./components/ListaEncomenda";
import Container from "components/Container";

function EncomendaListaPage() {
  useBreadcrumb([
    { name: "Administração" },
    { name: "Encomendas", url: "/administracao/encomenda" },
  ]);
  return (
    <Container>
      <ListaEncomenda />
    </Container>
  );
}

export default EncomendaListaPage;
